import React from "react";
// import QrReader from "react-qr-reader";
import Header from "../../../Common/header";

function QrScanner() {
  const [data, setData] = React.useState("Not Found");
  let handleScan = (data:any ) =>{
    console.log(data)
  };
  let handleError = (err:any) => {
    console.error(err)
  }

  return (
    <>
    <div><Header pageName={""}/></div>
        {/* <QrReader
          delay={300}
          onError={(err) => {}}
          onScan={(data) => {}}
          style={{ width: '100%' }}
        /> */}
      <p>{data}</p>
    </>
  );
}

export default QrScanner;